export const spanishCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        origin: "Canal de origen",
        sector: "Sector",
        name: "Nombre",
        website: "Sitio web",
        linkedin_url: "LinkedIn",
        instagram: "Instagram",
        tiktok: "TikTok",
        facebook: "Facebook",
        youtube: "YouTube",
        maps_url: "Google Maps",
        email: "Email",
        phone_number: "Teléfono",
        rating: "Calificación",
        reviews_count: "Reseñas",
        city: "Ciudad",
        address: "Dirección",
        list_id: "Carpeta",
      },
      empty: {
        title: "No hay empresas",
        description: "Crea una carpeta (nicho + ciudad) e importa el CSV.",
      },
      action: {
        new: "Nueva empresa",
        create: "Crear empresa",
        edit: "Editar empresa",
        show: "Ver empresa",
      },
      no_contacts: "Sin contactos",
      folders: {
        title: "Carpetas",
        create: "Crear carpeta",
        create_title: "Nueva carpeta de empresas",
        create_help:
          "El sector queda en la carpeta. La zona va en el título, por ejemplo salones_belleza_Bogotá.",
        name: "Nombre de la carpeta",
        created: "Carpeta creada",
        create_error: "No se pudo crear la carpeta",
        empty: "Crea una carpeta (nicho + ciudad) y después importa el CSV.",
        choose: "Elige una carpeta",
        active_help: "El CSV de esta carpeta hereda el sector y la zona.",
      },
      import: {
        button: "Importar CSV",
        title: "Importar empresas desde CSV",
        help: "Primero crea la carpeta (nicho + ciudad). El CSV hereda sector y zona. No crea negocios en el pipeline.",
        complete:
          "Importación lista. Abre cada empresa y usa Iniciar negocio cuando haya contacto real.",
        success: "Importación de CSV exitosa",
        failed: "No se importó ninguna empresa",
        failed_help:
          "Usa el CSV de ARKA Maps (columna nombre). Si el archivo es el crudo de Google, también sirve si trae title o nombre.",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Información",
        catalog: "Catálogo y recompra",
        identity: "Identidad",
        misc: "Otros datos",
        personal_info: "Datos de contacto",
        position: "Cargo",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        last_seen: "Última vez",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Correos",
        email: "Correo",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "LinkedIn",
        background: "Notas",
        has_newsletter: "Acepta mensajes",
        sales_id: "Responsable",
        product_line: "Línea",
        products: "Productos comprados",
        products_help: "Por ejemplo: maca roja, melena de león, cacao.",
        health_goal: "Objetivo",
        last_purchase_date: "Última compra",
        repurchase_days: "Recompra cada (días)",
        repurchase_days_help:
          "Depende del producto. Cuando se pase ese ciclo, mueve el negocio a Por recomprar.",
        lifetime_value: "Total comprado (COP)",
        origin: "De dónde llegó",
        marketing_consent: "Acepta que le escriban",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Elle",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Casa",
          other: "Otro",
        },
      },
    },
    deals: {
      name: "Negocio |||| Negocios",
      fields: {
        name: "Nombre",
        stage: "Etapa",
        amount: "Valor cotizado",
        origin: "Canal de origen",
        category: "Familia",
        product: "Producto o servicio",
        product_detail: "Detalle",
        currency: "Moneda",
        billing_type: "Forma de cobro",
        monthly_amount: "Mensualidad",
        purchase_date: "Fecha de compra / inicio",
        delivery_date: "Fecha de entrega",
        diagnosis_date: "Fecha del diagnóstico",
        company_id: "Empresa",
        company_optional_help:
          "Solo si compra a nombre de una empresa. Una persona puede ir sin compañía.",
        sale_kind: "Tipo de venta",
        sale_kind_help:
          "Persona del catálogo, o empresa con pedido grande. El tablero es el mismo.",
        order_detail: "Pedido",
        order_detail_help: "Qué pidió: producto, cantidad y presentación.",
        order_amount: "Valor del pedido",
        order_amount_help: "Lo que va a pagar. Desde carrito armado.",
        expected_closing_date: "Cierre estimado",
        description: "Descripción",
        contact_ids: "Contactos",
        repurchase_date: "Fecha de recompra",
      },
      action: {
        new: "Nuevo negocio",
        create: "Crear negocio",
        advance_to: "Avanzar a %{stage}",
        advance_error: "No se pudo avanzar el negocio",
      },
      empty: {
        title: "No hay negocios",
        description: "El pipeline está vacío.",
        before_create: "antes de crear un negocio.",
      },
      updated: "Negocio actualizado",
      inputs: {
        linked_to: "Vinculado a",
      },
      archived: {
        action: "Archivar",
        error: "No se pudo archivar el negocio",
        list_title: "Negocios archivados",
        success: "Negocio archivado",
        title: "Negocio archivado",
        view: "Ver archivados",
      },
      unarchived: {
        action: "Volver al tablero",
        error: "No se pudo devolver el negocio",
        success: "Negocio devuelto al tablero",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        display_name: "Usuario",
        display_name_help:
          "Así te saluda el CRM. El nombre es quien creó la cuenta.",
        email: "Correo",
        password: "Contraseña inicial",
        administrator: "Administrador",
        disabled: "Desactivado",
      },
      create: {
        title: "Nuevo usuario",
        success: "Usuario creado. Ya puede entrar con esa contraseña.",
        error: "No se pudo crear el usuario.",
      },
    },
    tasks: {
      name: "Actividad |||| Actividades",
      forcedCaseName: "Actividad",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
    },
  },
  crm: {
    nav: {
      home: "Métricas",
      contacts: "Contactos",
      companies: "Empresas",
      pipeline: "Pipeline",
      activities: "Actividades",
      workspace: "Workspace",
      account: "Cuenta",
      collapse_sidebar: "Ocultar menú",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellido",
      welcome_title: "Bienvenido a ARKA CRM",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea el primer usuario para terminar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado",
      },
      sign_in_failed: "No se pudo iniciar sesión.",
    },
    dashboard: {
      greeting: "Hola",
      title: "Métricas",
      kpi_won: "Ingresos ganados",
      kpi_open: "Negocios activos",
      kpi_winrate: "Tasa de cierre",
      kpi_velocity: "Velocidad pipeline",
      days: "días",
      pipeline_by_stage: "Pipeline por etapa",
      pipeline_summary: "Tienes %{open} negocios abiertos en el pipeline.",
      recent_deals: "Negocios recientes",
      no_deals: "Aún no hay negocios. Crea uno en Pipeline.",
      latest_activity: "Actividad reciente",
      upcoming_tasks: "Tareas próximas",
      origin_channels: "Canales de captación",
      stepper: {
        install: "Instalar ARKA CRM",
      },
    },
    settings: {
      title: "Ajustes",
    },
    language: "Idioma",
    common: {
      activity: "Actividad",
      me: "Yo",
    },
    deals: {
      start: "Iniciar negocio",
      start_title: "Pasar a Captado",
      start_help:
        "Elige cómo contactaste a este cliente. El negocio entra al pipeline en Captado, sin precio todavía.",
      start_confirm: "Crear en Captado",
      start_error: "No se pudo crear el negocio",
      started: "Negocio creado en Captado",
      already_open:
        "Ya hay un negocio abierto. Puedes crear otro si es una venta distinta.",
      inbound: "Lead inbound",
      inbound_title: "Cliente que llegó solo",
      inbound_help:
        "Crea la empresa y el negocio en Captado. Usa el canal real (WhatsApp, Instagram, web, LinkedIn).",
      inbound_created: "Lead inbound creado en Captado",
      closing_goal: "Meta de cierre",
      closing_on_time: "A tiempo",
      closing_late: "Tarde",
    },
  },
  ra: {
    page: {
      dashboard: "Inicio",
    },
    auth: {
      sign_in: "Entrar",
      username: "Usuario",
      password: "Contraseña",
      email: "Email",
    },
    action: {
      create: "Crear",
      export: "Exportar",
      edit: "Editar",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      add: "Añadir",
      show: "Ver",
      search: "Buscar",
      confirm: "Confirmar",
    },
  },
};
